export default __webpack_public_path__ + "src/assets/Swap_Desktop.86437f7cd86ed55b6e6050a7669868fc.svg";